import JobProductList from './pages/ListPage.vue'
import JobProductDetail from './pages/FormPage.vue'
import JobProductIndex from './pages/IndexPage.vue'

export default [
  {
    path: '/job_product',
    component: JobProductIndex,
    redirect: '/job_product/list',
    name: 'job_product',
    children: [
      {
        path: 'list',
        component: JobProductList,
        name: 'job_product.list'
      },
      {
        path: 'create',
        component: JobProductDetail,
        name: 'job_product.create',
        props: {create: true},
      },
      {
        path: 'edit/:id',
        component: JobProductDetail,
        name: 'job_product.edit',
        props: {create: false},
      },
    ],
  },
]
